<template>
    <div class="gallery_page">
         <titleArea></titleArea>
  <galleryArea></galleryArea>
    </div>
</template>

<script>
import titleArea from '@/components/gallery/titleArea.vue';
import galleryArea from '@/components/gallery/galleryArea.vue';
export default {
  components: { galleryArea , titleArea },
  name: "Gallery",
    mounted(){
         document.body.classList.add('Gallery');
    },
    destroyed(){
      document.body.classList.remove('Gallery');
    }
};
</script>